import React from 'react'
import { Stack } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { J2Caution, J2Copy } from '@e3dc-react/icons'
import { useCopyToClipboard } from 'src/Elements/CopyToClipboard/hook/use-copy-to-clipboard'
import ApiAccessInformationTile from './ApiAccessInformationTile'

export interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  secret: string
}

const useStyles = makeStyles()(theme => ({
  content: {
    marginBottom: 0,
  },
  secretContainer: {
    justifyContent: 'space-between',
  },
}))

const CopySecretDialog: React.FC<Props> = ({ onClose, isOpen, onConfirm, title, secret }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const { copyToClipboard } = useCopyToClipboard()

  const modalActions = {
    primary: {
      name: t('user.user-profile.api-access.copy-secret-dialog.done'),
      onClick: onConfirm,
    },
  }

  const handleCopySecret = (): void => {
    copyToClipboard(secret)
  }

  return (
    <Dialog maxWidth="sm" title={title} actions={modalActions} onClose={onClose} contentClassName={classes.content}>
      <Stack gap={2}>
        <ApiAccessInformationTile
          message={secret}
          rightIcon={<J2Copy sx={{ cursor: 'pointer' }} onClick={handleCopySecret} />}
          containerClassName={classes.secretContainer}
        />
        <ApiAccessInformationTile message={t('user.user-profile.api-access.copy-secret-dialog.info')} leftIcon={<J2Caution />} />
      </Stack>
    </Dialog>
  )
}

export default CopySecretDialog
